import { gql } from "@apollo/client";

export const CREAE_GENERAL_INVOICE = gql`
mutation CreateGeneralInvoice($input: GeneralInvoiceInput) {
  createGeneralInvoice(input: $input) {
    status
    message
  }
}
`;

export const GET_PRICE_TO_PAY_BY_GRADE = gql`
query Query($gradeId: ID, $payAs: AllowPaid) {
  getPriceToPayByGrade(gradeId: $gradeId, payAs: $payAs)
}
`;

export const VOID_GENERAL_INVOICE = gql`
mutation VoidGeneralInvoice($id: ID!, $isVoided: Boolean) {
  voidGeneralInvoice(_id: $id, isVoided: $isVoided) {
    status
    message
  }
}`;



export const GET_GENERAL_INVOICE_BY_ID = gql`
query GetGeneralInvoiceById($invoiceId: ID!) {
  getGeneralInvoiceById(invoiceId: $invoiceId) {
    _id
    invoiceNo
    currency
    date
    billTo {
      customerNameLatin
      customerNameKhmer
      companyName
      gender
      phone
    }
    vat
    vatAmount
    totalAmount
    exchangeRate
    items {
      itemId {
        itemName
      }
      amount
      key
      startDate
      endDate
      description
    }
    paymentStatus
    isVoided
    paidAmount
    note
    createdBy {
      lastName
      firstName
    }
    createdAt
    updatedAt
  }
} 
`;


export const GET_GENERAL_INVOICE_PAGINATION = gql`
query GetGeneralInvoicePagination(
  $page: Int
  $limit: Int 
  $keyword: String
  $pagination: Boolean
  $startDate: String
  $endDate: String
  $paymentStatus: String
  $invoiceId: Int
) {
  getGeneralInvoicePagination(
    page: $page
    limit: $limit
    keyword: $keyword
    pagination: $pagination
    startDate: $startDate
    endDate: $endDate
    paymentStatus: $paymentStatus
    invoiceId: $invoiceId
  ) {
    data {
      _id
      invoiceNo
      currency
      date
      billTo {
        customerNameLatin
        customerNameKhmer
      }
      vat
      vatAmount
      totalAmount
      exchangeRate
      items {
        itemId {
          itemName
          incomeType
        }
        amount
        key
        startDate
        endDate
        description
      }
      paymentStatus
      isVoided
      paidAmount
      note
      createdAt
      updatedAt
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}

`;
